import React, { Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './i18n/i18n';
import Loading from './components/Loading';
import { useAccessibilityPrefs } from './hooks/useAccessibilityPrefs';
import AppShell from './layout/AppShell';
import AppRoutes from './routes/AppRoutes';

const App: React.FC = () => {
  useAccessibilityPrefs(); // applies persisted a11y prefs to :root on mount

  return (
    <Suspense fallback={<Loading aria-live="polite" />}>
      <AppShell>
        <AppRoutes />
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar
          newestOnTop
          closeOnClick
          pauseOnHover
          theme="colored"
        />
      </AppShell>
    </Suspense>
  );
};

export default App;
